import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { Row, Card, Input, Label, Button, Col } from "reactstrap";
import Linkify from "react-linkify";
import { isNullOrEmpty } from "../../../../config/ENV";
import { JobBoardService } from "../../../../services/JobBoardService";
import defaultpostingimg from "../../../../../src/assets/img/jobboard/TA-90px.gif"
const JobBoardPost = (props) => {
  const { parentCallback, jobStatus, updateJobBoard } = props;
  const [jobBoards, setJobBoards] = useState([]);
  const [selectedJobBoardId, setSelectedJobBoardId] = useState("");
  const [selectedJobBoardName, setSelectedJobBoardName] = useState("");
  const [selectedJobBoardLogo, setSelectedJobBoardLogo] = useState("");
  const [jobBoardPostsUpdate, setJobBoardPostsUpdate] = useState([]);
  const [jobBoardPostNewList, setJobBoardPostNewList] =
    useState(updateJobBoard);
  const [postText, setPostText] = useState("");

  let count = 0;
  useEffect(() => {
    getjobBoard();
  }, [count]);

  const getjobBoard = () => {
    JobBoardService.getJobBoardPost().then((response) => {
      try {
        let jobBoards = response.data.jobBoards;
        setJobBoards(jobBoards);
        setSelectedJobBoardName(jobBoards.name);
        setSelectedJobBoardLogo(jobBoards.logo);
      } catch (err) {
        console.log("message" + JSON.stringify(err.message));
      }
    });
  };
  const handlepostText = (e) => {
    setPostText(e.target.value);
  };

  const handleDeleteJobBoard = (index) => {
    var deletedList = [...updateJobBoard];
    deletedList.splice(index, 1);
    
    parentCallback(deletedList);
    setJobBoardPostNewList(deletedList);
  };

  const handlejobBoardPosts = (e) => {
    var selectedName = e.target.value;
    if (isNullOrEmpty(e.target.value)) {
      setSelectedJobBoardId("");
      setSelectedJobBoardName("");
      setSelectedJobBoardLogo("");
    } else {
      jobBoards.map((jobBoard) => {
        if (jobBoard.name === selectedName) {
          setSelectedJobBoardId(jobBoard.id);
          setSelectedJobBoardName(jobBoard.name);
          setSelectedJobBoardLogo(jobBoard.logo);
        }
      });
    }
  };

  const clickAddButton = () => {
    if (isNullOrEmpty(selectedJobBoardName)) {
      toast.error("Please select job board");
      return;
    }
    if (isNullOrEmpty(postText)) {
      toast.error("Please enter job board post URL");
      return;
    }

    var list = [...updateJobBoard];
    var obj = {
      logo: selectedJobBoardLogo,
      jobBoardId: selectedJobBoardId,
      postUrl: postText,
      jobBoardName: selectedJobBoardName,
    };
    list.push(obj);
    setJobBoardPostsUpdate(list);
    parentCallback(list);
    setSelectedJobBoardName("");
    setSelectedJobBoardLogo("");
    setPostText("");
  };

  const handleLinkify = (event) => {
    event.preventDefault();
    window.open(event.target.href, "_blank");
  };

  return (
    <>
        <Label className="lable-text mt-3 ml-3"> Job Board Postings</Label>

        <div disabled={jobStatus == "CLOSED"}>
          <>
            <Row className="ml-3 mt-4">
              <Col sm={4}>
                <Input
                  className="t-rounded-lg"
                  type="select"
                  data-testid="templateId"
                  value={selectedJobBoardName}
                  onChange={(e) => handlejobBoardPosts(e)}
                  disabled={jobStatus == "CLOSED"}
                >
                  <option value="">Select Job Board</option>
                  {jobBoards.length > 0 &&
                    jobBoards.map((jobBoard, index) => {
                      return (
                        <option key={jobBoard.id} value={jobBoard.name}>
                          {jobBoard.name}
                        </option>
                      );
                    })}
                </Input>
              </Col>
              <Col sm={6}>
                <Input
                  type="text"
                  placeholder="Enter job board post url"
                  value={postText}
                  onChange={(e) => handlepostText(e)}
                />
              </Col>
              <Col sm={2}>
                <Button
                  className="my-2"
                  color="primary"
                  size="sm"
                  data-toggle="modal"
                  outline
                  onClick={(e) => clickAddButton(e)}
                >
                  Add
                </Button>
              </Col>
            </Row>
          </>
        </div>
        {updateJobBoard.length > 0 &&
          updateJobBoard.map((jobPostings, index) => {
            return (
              <>
                <Row className="mt-3 ml-3">
                  <Col sm={2} className="">
                    {!isNullOrEmpty(jobPostings.logo)?(<>
                      <img
                      src={jobPostings.logo}
                      className="account-logo"
                      alt="Job Board Post"
                    />
                    </>):(<>
                    <img
                    src={defaultpostingimg}
                    className="account-logo"
                      alt="Job Board Post"/>
                    
                    </>) }
                    
                  </Col>
                  <Col sm={3}> {jobPostings.jobBoardName} </Col>
                  <Col sm={5} className="mb-2">
                    <Linkify
                      componentDecorator={(
                        decoratedHref,
                        decoratedText,
                        key
                      ) => (
                        <a
                          href={decoratedHref}
                          key={key}
                          onClick={handleLinkify}
                        >
                          {decoratedText}
                        </a>
                      )}
                      target="_blank" // This sets the target attribute for all links
                    ><span className="t-inputfield-width">
                      {jobPostings.postUrl}</span>
                    </Linkify>
                  </Col>
                  <Col sm={2}>
                    <i
                      type="button"
                      data-toggle="modal"
                      data-target="#exampleModalside"
                      title="Delete job board post"
                      className="simple-icon-trash edit-copyiconsize arrow-icon-color emp_icon t-jobpost-delete-icon"
                      // onClick={() => handleDeleteJobBoard(index)}
                      onMouseDown={() => handleDeleteJobBoard(index)}
                      onKeyUp={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          handleDeleteJobBoard(index);
                        }
                      }}
                      tabIndex="0" 
                    />
                  </Col>
                </Row>
              </>
            );
          })}
    </>
  );
};
export default JobBoardPost;
